// 마커 - 정리중

// Dot 타입
export { default as MarkerBookmarkIcon } from './marker_icon_bookmark.svg' // dot 타입 저장 마커 // TODO: 사용되지 않음

// 엣지(사진, 가격 타입)
export { default as MarkerEdgeIcon } from './marker_default_edge.svg' // 엣지

// 핀(핀 타입)
export { default as MarkerPinIcon } from './marker_default_pin.svg' // 핀

// 업종
export { default as MarkerRestaurantIcon } from './marker_icon_restaurant.svg' // 식당
export { default as MarkerCafeIcon } from './marker_icon_cafe.svg' // 카페
export { default as MarkerPubIcon } from './marker_icon_pub.svg' // 술집/펍
export { default as MarkerPensionIcon } from './marker_icon_pension.svg' // 펜션
export { default as MarkerCampingIcon } from './marker_icon_camping.svg' // 캠핑 // TODO: 사용되지 않음
export { default as MarkerHairShopIcon } from './marker_icon_hairshop.svg' // 미용실
export { default as MarkerNailShopIcon } from './marker_icon_nailshop.svg' // 네일샵
export { default as MarkerHospitalIcon } from './marker_icon_hospital.svg' // 병원
export { default as MarkerPharmacyIcon } from './marker_icon_pharmacy.svg' // 약국 (서비스 안함) // TODO: 사용되지 않음
export { default as MarkerGasIcon } from './marker_icon_gas.svg' // 주유소 - 모바일 기본형 png로 적용, PC 기본형 svg로 적용 // TODO: 사용되지 않음
export { default as MarkerCvsIcon } from './marker_icon_cvs.svg' // 편의점 - 모바일 기본형 svg로 적용, PC 범용으로 처리 // TODO: 사용되지 않음
export { default as MarkerPlaceIcon } from './marker_icon_place.svg' // 범용
export { default as MarkerPlaceDotIcon } from './marker_icon_place_dot.svg' // 범용 Dot타입
export { default as MarkerPollIcon } from './marker_icon_poll.svg' // 투표소 // TODO: 사용되지 않음
export { default as MarkerCouponIcon } from './marker_icon_coupon.svg' // 플레이스쿠폰(신규아이콘) - 적용 필요 // TODO: 사용되지 않음
export { default as MarkerEVStationIcon } from './marker_icon_ev_station.svg' // 전기차충전소(기본) // TODO: 사용되지 않음
export { default as MarkerEVStationTypeMoveIcon } from './marker_icon_ev_station_type_move.svg' // 전기차충전소(이동형) // TODO: 사용되지 않음
export { default as MarkerCourseIcon } from './marker_icon_course.svg' // 산 전체코스 섹션 - 모바일만 노출 // TODO: 사용되지 않음
export { default as MarkerVisitedIcon } from './marker_icon_visited.svg' // 타임라인 - 방문
